<app-header></app-header>
<app-slider></app-slider>
<app-tariffs></app-tariffs>
<app-main-info></app-main-info>
<app-footer></app-footer>
